import glamorous from 'glamorous';

import { media } from '../../../styles';

const Nav = glamorous.nav({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',

  height: 56,
  padding: '0 16px',

  color: '#fff',

  transition: 'background linear 0.1s',
}, props => ({
  background: props.theme.primary.base,

  [media('sm', { isMax: true })]: {
    display: props.isViewingEvent ? 'none' : 'flex',
  },
}));

export default Nav;



// WEBPACK FOOTER //
// ./src/components/layout/Nav/Nav.js